document.addEventListener('click', function (e) {
  const btn = e.target.closest('.js-qty__adjust');
  if (!btn) return;

  const qtyWrapper = btn.closest('.js-qty');
  if (!qtyWrapper) return;

  const input = qtyWrapper.querySelector('.js-qty__num');
  if (!input) return;

  let value = parseInt(input.value, 10) || 1;
  const min = parseInt(input.getAttribute('min'), 10) || 1;

  if (btn.classList.contains('js-qty__adjust--plus')) {
    value += 1;
  }

  if (btn.classList.contains('js-qty__adjust--minus')) {
    value = Math.max(min, value - 1);
  }

  input.value = value;

  // 🔥 force theme + Shopify to accept change
  input.dispatchEvent(new Event('change', { bubbles: true }));
  input.dispatchEvent(new Event('input', { bubbles: true }));
});
